// 英文
export default {
  /* SOP主播招募 */
  recruitment: {
    lang1: "活動規則",
    lang2: "實況",
    lang3: "往期",
    lang4: "您已放棄今日參賽",
    lang5: "放棄今日參數失敗",
    lang6: "放棄參賽",
    lang7: "我的排名",
    lang8: "勝場",
    lang9: "參賽説明",
    lang10: "請晉級半決賽/決賽的主播在半決賽/決賽開始的時間保持開播狀態且未在PK中,系統將自動發起半決賽/決賽雙方主播的PK。",
    lang11: "半決賽",
    lang12: "5局3勝制,獲勝主播晉級決賽",
    lang13: "海選No.1 VS 海選No.4",
    lang14: "海選No.2 VS 海選No.3",
    lang15: "決賽",
    lang16: "5局3勝制,獲勝主播成為當日「熒光夜間選秀」冠軍",
    lang17: "半決賽勝者",
    lang18: "注：如果您滿足半決賽/決賽參與條件但無法參與，請在每天20:30之前點擊",
    lang19: "放棄參賽 >",
    lang20: "缺席比賽將在未來14天無法參加「熒光夜間選秀」活動",
    lang21: "放棄參賽",
    lang22: "放棄參賽將退出海選階段排名,次日將恢復您的參賽資格。",
    lang23: "是否放棄參加今日",
    lang24: "的「熒光夜間選秀」活動",
    lang25: "取消",
    lang26: "確認",
    lang27: "勝場",
    lang28: "未完賽",
    lang29: "暫無往期記錄",
    lang30: "參與「熒光夜間選秀」",
    lang31: "主播使用FIREFLY V54.0以上版本開啟PK（包含「人氣PK」和「遊戲PK」），即可參加「熒光夜間選秀」活動。",
    lang32: "海選",
    lang33: "時間：每日23:00-次日20:30",
    lang34: "規則：榜單記錄主播當日參與PK的最高人氣值，以當日PK場次的最高人氣值進行排名",
    lang35: "晉級：截止每日20:30，海選前4名主播晉級半決賽",
    lang36: "放棄參賽：如果主播無法在半決賽/決賽的指定時間開播，可以在海選時間段內選擇放棄參賽。主播放棄參賽後排名下一位的主播將頂上。",
    lang37: "半決賽",
    lang38: "時間：每日21:00/21:20",
    lang39: "規則：系統將在指定時間自動發起半決賽雙方主播的PK，PK規則為「人氣PK」5局3勝制。請主播在此時間內保持開播狀態。",
    lang40: "晉級：贏家將晉級決賽",
    lang41: "放棄參賽：主播在半決賽開始時未在開播狀態，視為放棄參賽。無法獲得名次獎勵，並在未來15天無法再次參與「熒光夜間選秀」",
    lang42: "半決賽1：海選No.1 vs 海選 No.4",
    lang43: "半決賽2：海選No.2 vs 海選 No.3",
    lang44: "半決賽失敗方根據當日最高人氣值排名，決出No.3/No.4",
    lang45: "決賽",
    lang46: "時間：每日22:00",
    lang47: "規則：系統將在指定時間自動發起決賽雙方主播的PK，PK規則為「人氣PK」5局3勝制。請主播在此時間內保持開播狀態。",
    lang48: "晉級：贏家獲得當日「熒光夜間選秀」冠軍",
    lang49: "放棄參賽：主播在決賽開始時未在開播狀態，視為放棄參賽。無法獲得名次獎勵，並在未來15天無法再次參與「熒光夜間選秀」",
    lang50: "決賽勝利方為當日冠軍，失敗方為當日No.2",
    lang51: "獎勵",
    lang52: "玩家露水獎勵：",
    lang53: "半決賽1：獲勝方的隊伍將平分",
    lang54: "半決賽2：獲勝方的隊伍將平分",
    lang55: "決賽：獲勝方的隊伍將平分",
    lang56: "主播積分獎勵：",
    lang57: "參與半決賽/決賽的主播，決出勝負之後，前4名可以獲得「直播獎勵」的積分。放棄參賽的主播將無法獲得積分獎勵。具體積分請查看",
    lang58: "「直播獎勵」>",
    lang59: "注意事項",
    lang60: "1.活動僅限女性主播參與",
    lang61: "2.被限制活動參與資格期間，所有活動數據均為無效數據，需在接觸限制後重新獲取",
    lang62: "3.主播需積極與玩家互動，有違反《主播直播公約》以及破壞活動平衡的行為，平台有權取消其活動資格以及活動積分（包括但不限於掛臉直播、無質量、黑屏、掛機、直播打遊戲、看電視等）",
    lang63: "4. 活動最終解釋權歸平台所有",
    lang64: "海選中",
    lang65: "23:00-次日20:30",
    lang66: "開啓PK即可參與海選排名,榜單記錄當日PK最高任期至,排名前4名晉級半決賽",
    lang67: "晋级区",
    lang68: "暫無海選記錄",
    lang69: "「FIREFLY」您預約了熒光夜間選秀決賽",
    lang70: "每天21:00-23:00，PK贏露水獎勵",
    lang71: "決賽主播未決出",
    lang72: "半决赛主播未决出",
    lang73: "半決賽勝者",
    lang74: "海选 NO.1",
    lang75: "海选 NO.2",
    lang76: "海选 NO.3",
    lang77: "海选 NO.4",
    lang78: "订阅提醒 >",
    lang79: "獲勝隊伍獎勵",
    lang80: "五局三胜",
  }
};
